import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
class ReviewsPagination extends React.Component {
  static propTypes = {
    page: PropTypes.number,
    count: PropTypes.number,
    perPage: PropTypes.number,
    pagingCallback: PropTypes.func,
  };
  changePage = direction => {
    var page;

    if (direction === "next") {
      page = this.props.page + 1;
    } else {
      page = this.props.page - 1;
    }

    this.props.pagingCallback(page);
  };

  render() {
    return (
      <div className="review-pagination">
        <div>See more reviews:</div>
        <div className="label">
          <button
            className="pagination-nav pagination-nav-prev mr-1"
            disabled={this.props.page <= 1}
            title="Previous page"
            onClick={_.partial(this.changePage, "prev")}>
            Previous
          </button>
          {this.props.page} / {Math.ceil(this.props.count / this.props.perPage)}
          <button
            className="pagination-nav pagination-nav-next ml-1"
            disabled={this.props.page * 40 >= this.props.count}
            title="Next page"
            onClick={_.partial(this.changePage, "next")}>
            Next
          </button>
        </div>
      </div>
    );
  }
}

export default ReviewsPagination;
